import React from 'react';
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton
} from '@coreui/react';

const CommonModal = ({
  visible,
  onClose,
  title,
  children,
  size = 'lg',
  footer,
  showFooter = true,
  cancelText = 'Cancel',
  confirmText = 'Save',
  onConfirm,
  showCancel = true,
  showConfirm = true,
  confirmColor = 'primary',
  backdrop = true,
  customHeaderClass = ''
}) => {
  return (
    <CModal
      visible={visible}
      onClose={onClose}
      size={size}
      backdrop={backdrop}
    >
      <CModalHeader className={customHeaderClass}>
        <CModalTitle className="fw-bold">{title}</CModalTitle>
      </CModalHeader>
      
      <CModalBody className="p-4">
        {children}
      </CModalBody>

      {showFooter && (
        <CModalFooter>
          {footer ? (
            footer
          ) : (
            <>
              {showCancel && (
                <CButton color="secondary" onClick={onClose}>
                  <i className="fas fa-times me-2"></i>{cancelText}
                </CButton>
              )}
              {showConfirm && onConfirm && (
                <CButton color={confirmColor} onClick={onConfirm}>
                  <i className="fas fa-check me-2"></i>{confirmText}
                </CButton>
              )}
            </>
          )}
        </CModalFooter>
      )}
    </CModal>
  );
};

export default CommonModal;